import React, { useEffect, useState, Fragment } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage, Language } from '../contexts/LanguageContext';
export function Navigation() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const navLinks = [{
    name: t.nav.home,
    href: '#home'
  }, {
    name: t.nav.sales,
    href: '#prodej'
  }, {
    name: t.nav.rental,
    href: '#pronajem'
  }, {
    name: t.nav.gallery,
    href: '#galerie'
  }, {
    name: t.nav.location,
    href: '#lokalita'
  }, {
    name: t.nav.contact,
    href: '#kontakt'
  }];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      // Simple scrollspy
      const sections = navLinks.map(link => link.href.substring(1));
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) {
        setActiveSection(current);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [navLinks]);
  const languages: {
    code: Language;
    label: string;
  }[] = [{
    code: 'en',
    label: 'EN'
  }, {
    code: 'de',
    label: 'DE'
  }, {
    code: 'fr',
    label: 'FR'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-charcoal-900/95 backdrop-blur-md py-4 shadow-lg shadow-black/20' : 'bg-transparent py-6'}`} data-id="element-133">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-134">
          <a href="#home" className="text-2xl font-heading font-bold tracking-wider text-cream flex flex-col" data-id="element-135">
            <span data-id="element-136">MALOSTRANSKÁ</span>
            <span className="tracking-[0.3em] text-gold uppercase font-body text-[16px]" data-id="element-137">
              RESIDENCE
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-138">
            <nav className="flex items-center space-x-8" data-id="element-139">
              {navLinks.map(link => <a key={link.href} href={link.href} className={`text-sm tracking-widest uppercase transition-colors duration-300 ${activeSection === link.href.substring(1) ? 'text-gold' : 'text-cream/80 hover:text-cream'}`} data-id="element-140">
                  {link.name}
                </a>)}
            </nav>

            <div className="w-[1px] h-4 bg-cream/20" data-id="element-141"></div>

            <div className="flex items-center space-x-3 text-sm tracking-widest font-light" data-id="element-142">
              {languages.map((lang, index) => <Fragment key={lang.code} data-id="element-143">
                  <button onClick={() => setLanguage(lang.code)} className={`transition-colors duration-300 ${language === lang.code ? 'text-gold font-semibold' : 'text-cream/60 hover:text-cream'}`} data-id="element-144">
                    {lang.label}
                  </button>
                  {index < languages.length - 1 && <span className="text-cream/20" data-id="element-145">|</span>}
                </Fragment>)}
            </div>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-cream p-2" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-146">
            <Menu className="w-6 h-6" data-id="element-147" />
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-148">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} transition={{
        type: 'tween',
        duration: 0.4
      }} className="fixed inset-0 z-[60] bg-charcoal-900 flex flex-col justify-center items-center" data-id="element-149">
            <button className="absolute top-6 right-6 text-cream p-2" onClick={() => setIsMobileMenuOpen(false)} aria-label="Close menu" data-id="element-150">
              <X className="w-8 h-8" data-id="element-151" />
            </button>

            <nav className="flex flex-col items-center space-y-8" data-id="element-152">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-heading text-cream hover:text-gold transition-colors" data-id="element-153">
                  {link.name}
                </a>)}
            </nav>

            <div className="mt-12 flex items-center space-x-4 text-lg tracking-widest font-light" data-id="element-154">
              {languages.map((lang, index) => <Fragment key={lang.code} data-id="element-155">
                  <button onClick={() => {
              setLanguage(lang.code);
              setIsMobileMenuOpen(false);
            }} className={`transition-colors duration-300 ${language === lang.code ? 'text-gold font-semibold' : 'text-cream/60 hover:text-cream'}`} data-id="element-156">
                    {lang.label}
                  </button>
                  {index < languages.length - 1 && <span className="text-cream/20" data-id="element-157">|</span>}
                </Fragment>)}
            </div>

            <div className="mt-12 w-12 h-[1px] bg-gold" data-id="element-158"></div>
            <p className="mt-8 text-cream/60 tracking-widest uppercase text-sm" data-id="element-159">
              Malostranská, Praha 1
            </p>
          </motion.div>}
      </AnimatePresence>
    </>;
}